import BeerHover from 'images/nav/beer-hover.jpg';
import MixersHover from 'images/nav/mixers-hover.jpg';
import SpiritsHover from 'images/nav/spirits-hover.jpg';
import WineHover from 'images/nav/wine-hover.jpg';

const BEER = {
  tag: 'BE',
  img: { height: 208, src: BeerHover },
  name: 'Beer',
  subcategories: [
    { tag: '106' }, // Pilsner
    { tag: '86' }, // Light Lager
    { tag: '76' }, // India Pale Ale
    { tag: '15' }, // Belgian & French Ale
    { tag: '43' }, // Ciders
    { tag: '5' }, // American Ale
    { tag: '143' }, // Stout
    { tag: '139' }, // Specialty Beer
    { tag: '85' }, // Light Hybrid Beer
    { tag: '65' }, // German Wheat & Rye Beer
    { tag: '16' }, // Belgian Strong Ale
    { tag: '135' } // Sour Ale
  ]
};

const WINE = {
  tag: 'WN',
  img: { height: 208, src: WineHover }
};

const RED_WINE = {
  tag: 'RW',
  subcategories: [
    { tag: '29' }, // Cabernet Sauvignon
    { tag: '109' }, // Pinot Noir
    { tag: '113' }, // Red Blend
    { tag: '92' } // Malbec
  ]
};

const WHITE_WINE = {
  tag: 'WW',
  subcategories: [
    { tag: '127' }, // Sauvignon Blanc
    { tag: '38' }, // Chardonnay
    { tag: '108' }, // Pinot Grigio
    { tag: '118' } //  Riesling
  ]
};

const MORE_WINES = [
  { tag: 'RS' }, // Rosé
  { tag: 'SW' }, // Champagne & Sparkling
  { tag: 'SK' } // Sake
];

const SPIRITS = {
  tag: 'ST',
  img: { height: 208, src: SpiritsHover },
  subcategories: [
    { tag: 'WS' }, // Whiskey & Scotch
    { tag: 'VO' }, // Vodka'
    { tag: 'TQ' }, // Tequila & Mezcal
    { tag: 'RU' }, // Rum
    { tag: 'GN' }, // Gin
    { tag: 'SP', name: 'Cordials, Liqueurs & Bitters' },
    { tag: 'CO' }, // Cocktails & Combos
    { tag: '23' }, // Bourbon Whiskey
    { tag: '78' }, // Irish Whiskey
    { tag: '132' }, // Single Malt Scotch
    { tag: '18' }, // Blanco / Silver Tequila
    { tag: '115' }, // Reposado Tequila
    { tag: '8' } // 'Añejo Tequila
  ]
};

const MORE = {
  tag: 'OT',
  url: '/more',
  name: 'More',
  img: { height: 208, src: MixersHover },
  subcategories: [{ tag: 'MX' }, { tag: 'SN' }, { tag: 'TB' }]
};

export { BEER, WINE, RED_WINE, WHITE_WINE, MORE_WINES, SPIRITS, MORE };
